<template>
  <page-one v-if="type==3 || type==2"/>
  <page-two v-else-if="type==1 || type==5"/>
  <page-three v-else-if="type==4 || type==6"/>
</template>

<script>
import PageOne from './modules/page-one/index.vue'
import PageTwo from './modules/page-two/index.vue'
import PageThree from './modules/page-three/index.vue'
export default {
  components: { PageOne, PageTwo, PageThree },
  data() {
    return {
      type: null
    }
  },
  created() {
    this.type = this.$route.query.type
    if (!this.type) {
      this.$router.replace('/')
    } else {
      this.$wxShare(
        '2022年徐汇区“全国科普日”活动',
        '“新徐汇 新科普”云上嘉年华',
        'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_2a12fa0ad8df461b887daafe09631388.png'
      )
    }
  }
}
</script>

<style lang="scss">
$all-width: 94%;
.plate-one {
  display: flex;
  padding-top: .15rem;
  justify-content: space-between;
  width: $all-width;
  margin: 0 auto;
  height: .3rem;
  &-logo {
    height: 100%;
    img {
      width: auto;
      height: 100%;
    }
  }
}
.plate-two {
  &-title {
    width: 40%;
    margin: auto;
    margin-top: .3rem;
    margin-bottom: .1rem;
  }
}
</style>
